import { useEffect, useState } from "react";
import { Generico } from "../../components/Generico";
import { Consecuencia } from "../../models/riesgo/Consecuencia";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { Panel } from "primereact/panel";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";

export const Consecuencias = ({ permss, toast, generic, riesgo, tipo, funcionalidades, actualizarCatalogo }) => {
    const omodel = new Consecuencia();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [load, setLoad] = useState(false);
    const [dialogConsecuencia, setDialogConsecuencia] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { table, setLoading, setTotalRecords, lazyParams, inArea, inText, inNumber } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const configuracionPorTipo = {
        MTR_RIESGO_PROBABILIDAD: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-PROBABILIDAD'
        },
        MTR_RIESGO_CSC_RIESGO_CONTAGIO: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-CSC-RIESGO-CONTAGIO'
        },
        MTR_RIESGO_CSC_LEGAL: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-CSC-LEGAL'
        },
        MTR_RIESGO_CSC_OPERATIVO: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-CSC-OPERATIVO'
        },
        MTR_RIESGO_CSC_REPUTACIONAL: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-CSC-REPUTACIONAL'
        },
        MTR_RIESGO_RANQUEO: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-RANQUEO'
        },
        MTR_RIESGO_TIPO_CONTROL: {
            campos: ['orden', 'nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-TIPO-CONTROL'
        },
        MTR_RIESGO_EJECUCION_CONTROL: {
            campos: ['orden', 'nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-EJECUCION'
        },
        MTR_RIESGO_FRECUENCIA_CONTROL: {
            campos: ['orden', 'nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-FRECUENCIA'
        },
        MTR_RIESGO_SOLIDEZ_CONTROL: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-SOLIDEZ'
        },
        MTR_RIESGO_EFECTIVIDAD_CONTROL: {
            campos: ['nivel', 'descripcion'],
            funcionalidad: 'MATRIZ-RIESGOS-EDICION-EFECTIVIDAD'
        },
        DEFAULT: {
            campos: ['descripcion'],
            funcionalidad: null
        }
    };

    const camposPermitidos = configuracionPorTipo[tipo]?.campos ?? configuracionPorTipo.DEFAULT.campos;
    const funcionalidadRequerida = configuracionPorTipo[tipo]?.funcionalidad;

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.tipo = tipo;
        _lazyParams.matrizId = riesgo?.id;
        matrizSrv.listado('matriz-riesgo-consecuencia/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const onSubmit = (data) => {
        data.tipo = tipo;
        data.matrizId = riesgo?.id;
        setLoad(true);
        if (getValues('id') == null) {
            matrizSrv.nuevo(data, 'matriz-riesgo-consecuencia/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                actualizarCatalogo(tipo, res.data);
                setDialogConsecuencia(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        } else {
            matrizSrv.editar(data, 'matriz-riesgo-consecuencia/editar').then(res => {
                generic.funcSuccess(res, toast);
                actualizarCatalogo(tipo, res.data.catalogo, res.data.padreId, res.data.nuevoId);
                setDialogConsecuencia(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            }).finally(() => {
                setLoad(false);
            });
        }
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && siOpcion(funcionalidadRequerida))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editar() });
        if (permss?.eliminar && siOpcion(funcionalidadRequerida)) {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        return [{ label: 'Opciones', items }];
    };

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nuevo " : " Editar "}
                </span>
            </div>
        );
    }

    const editar = () => {
        matrizSrv.consultar(`${item?.id}/${tipo}`, 'matriz-riesgo-consecuencia/consulta').then(res => {
            const registro = generic.renewValues(res.data, omodel.model);
            reset(registro);
            setDialogConsecuencia(true);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogConsecuencia(true);
    }

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${tipo}?matrizId=${riesgo.id}`, 'matriz-riesgo-consecuencia/eliminar').then(res => {
            loadLazyData();
            actualizarCatalogo(tipo, res.data);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }


    const headerTemplate = (options) => {
        const puedeCrearTipo = !camposPermitidos?.includes('orden'); // si no se puede modificar el orden, no se puede crear
        if (!siOpcion(funcionalidadRequerida) || puedeCrearTipo) return null;
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" tooltip="Nuevo" onClick={openNew} />}
                </div>
            </div>
        );
    };

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Panel>

            <Dialog visible={dialogConsecuencia} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogConsecuencia(false);
            }}
                style={{ width: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {camposPermitidos.includes('orden') && inNumber('orden', 0, false, { min: omodel.model.orden?.min ?? 1, tooltip: 'Ingrese un número entre 1 y 5' }, 12)}
                        {camposPermitidos.includes('nivel') && inText('nivel', {}, 12)}
                        {camposPermitidos.includes('descripcion') && inArea('descripcion', 5, 30, 12)}
                    </div>
                    {generic.buttonsForms(setDialogConsecuencia, load)}
                </form>
            </Dialog>
        </>
    )
}
